import { render, staticRenderFns } from "./shadowBox.vue?vue&type=template&id=b51871b4&scoped=true"
var script = {}
import style0 from "./shadowBox.vue?vue&type=style&index=0&id=b51871b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51871b4",
  null
  
)

export default component.exports